import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { ButtonLabel } from './Button';
import { ArrowButton, Css } from '../../../ui';

interface ITextButton {
	onClick: () => void;
	iconPosition?: 'left' | 'right';
	disabled?: boolean;
	children: ReactNode;
}

export default function TextArrowButton({
	onClick,
	iconPosition = 'right',
	disabled,
	children,
}: ITextButton) {
	return (
		<StyledArrowButton
			textButton
			onClick={onClick}
			disabled={disabled}
			iconPosition={iconPosition}
		>
			<ButtonLabel>{children}</ButtonLabel>
		</StyledArrowButton>
	);
}

const StyledArrowButton = styled(ArrowButton)<ITextButton>`
	text-decoration: none;
	padding: ${Css.pxToRem(10)} ${Css.pxToRem(10)};

	svg {
		path {
			fill: currentColor;
		}
	}

	&:disabled {
		svg {
			path {
				fill: currentColor;
			}
		}
	}
`;
